// src/pages/Contact.tsx
import React from 'react';
import { Link } from 'react-router-dom';

import { useScrollingText } from "../hooks/useScrollingText";

import { useHorizontalScroll } from '../hooks/useHorizontalScroll';


import web from '../assets/images/services/web.webp';
import digital from '../assets/images/services/digital.webp';
import graphic from '../assets/images/services/graphic.webp';
import hosting from '../assets/images/services/hosting.webp';
import website from '../assets/images/services/website.webp';

const ServiceSection: React.FC = () => {



useScrollingText([
  {
    selector: ".services-scroll-text",
    direction: "left",
    scrollEffect: true,
    infinite: true,
  }
]);



useHorizontalScroll([
  { wrapperClass: '.services-scroll-wrapper', itemClass: '.services-scroll-item' }
]);

  return (


<>

  {/* ==== Services start ==== */}
<div className="rts-use-case-area-one">

  <div className="container-full">
    <div className="col-lg-12">
      <div className="main-wrapper-case-studies scrolltext-wrapper">
        <div className="services-scroll-text">
          <h2 className="title">
            our Services . our Services . our Services . our Services .
          </h2>
        </div>
      </div>
    </div>
  </div>


  {/* ==== banner start ==== */}
  <div className="service-section">
    <div className="services-scroll-wrapper d-flex flex-md-row flex-column">



      


 {/* Section Start */}

      <div className="services-scroll-item">
        <div className="projects-s__single topy-tilt">


    <div className="container mt--110 mt-md--50 mt-sm--30 services-bg">
      <div className="row align-items-center">
        {/* Text Column - 1st on desktop, 2nd on mobile */}
        <div className="col-lg-6 order-2 order-lg-1">
          <div className="content-wrapper">
            <span className="sub-title">Manikarn Digital</span>
            <h2 className="title mt--15 mb--20 mt_sm--10 mb_sm--10">WEB DESIGN AND DEVELOPMENT</h2>
            <p className="disc rts-text-anim">
              Stuck with an outdated website? Let’s fix that. We build modern, fast, and user-focused websites that do more than just look good - they attract visitors, drive action, and grow your business. From clean design to smart features, we make sure your site performs at its best.
            </p>
            <Link to="/web-design-development" className="learn-more-btn mt--30 mt_sm--10">
              More Details{" "}
              <i className="fa fa-arrow-up-right-from-square icn-size28"></i>
            </Link>
          </div>
        </div>

        {/* Image Column - 1st on mobile, 2nd on desktop */}
        <div className="col-lg-6 order-1 order-lg-2 img-wrapper d-block text-center mb_sm--20">
          <img className="img-fluid" src={web} alt="product" />
        </div>
      </div>
    </div>          


        </div>
      </div>
 {/* Section End */}


  {/* Section Start */}

      <div className="services-scroll-item">
        <div className="projects-s__single topy-tilt">


    <div className="container mt--110 mt-md--50 mt-sm--30 services-bg">
      <div className="row align-items-center">
        {/* Text Column - 1st on desktop, 2nd on mobile */}
        <div className="col-lg-6 order-2 order-lg-1">
          <div className="content-wrapper">
            <span className="sub-title">Manikarn Digital</span>
            <h2 className="title mt--15 mb--20 mt_sm--10 mb_sm--10">Digital Marketing</h2>
            <p className="disc rts-text-anim">
              Not getting the results you want online? Let’s change that. Our digital marketing strategies are built to perform - from increasing visibility to turning clicks into customers. We combine SEO, ads, content, and analytics to grow your brand where it matters most.
            </p>
            <Link to="/digital-marketing" className="learn-more-btn mt--30">
              More Details{" "}
              <i className="fa fa-arrow-up-right-from-square icn-size28"></i>
            </Link>
          </div>
        </div>

        {/* Image Column - 1st on mobile, 2nd on desktop */}
        <div className="col-lg-6 order-1 order-lg-2 img-wrapper d-block text-center mb_sm--20">
          <img className="img-fluid" src={digital} alt="product" />
        </div>
      </div>
    </div>          


        </div>
      </div>
 {/* Section End */}


  {/* Section Start */}

      <div className="services-scroll-item">
        <div className="projects-s__single topy-tilt">


    <div className="container mt--110 mt-md--50 mt-sm--30 services-bg">
      <div className="row align-items-center">
        {/* Text Column - 1st on desktop, 2nd on mobile */}
        <div className="col-lg-6 order-2 order-lg-1">
          <div className="content-wrapper">
            <span className="sub-title">Manikarn Digital</span>
            <h2 className="title mt--15 mb--20 mt_sm--10 mb_sm--10">Graphic Designing</h2>
            <p className="disc rts-text-anim">
              Designs that don’t just look good— they communicate, connect, and convert. We create visually powerful graphics that elevate your brand - whether it’s logos, social media posts, or full brand kits. Our designs are tailored to tell your story and make a lasting impression.
            </p>
            <Link to="/graphic-designing" className="learn-more-btn mt--30">
              More Details{" "}
              <i className="fa fa-arrow-up-right-from-square icn-size28"></i>
            </Link>
          </div>
        </div>

        {/* Image Column - 1st on mobile, 2nd on desktop */}
        <div className="col-lg-6 order-1 order-lg-2 img-wrapper d-block text-center mb_sm--20">
          <img className="img-fluid" src={graphic} alt="product" />
        </div>
      </div>
    </div>          



        </div>
      </div>
 {/* Section End */}


  {/* Section Start */}

      <div className="services-scroll-item">
        <div className="projects-s__single topy-tilt">


    <div className="container mt--110 mt-md--50 mt-sm--30 services-bg">
      <div className="row align-items-center">
        {/* Text Column - 1st on desktop, 2nd on mobile */}
        <div className="col-lg-6 order-2 order-lg-1">
          <div className="content-wrapper">
            <span className="sub-title">Manikarn Digital</span>
            <h2 className="title mt--15 mb--20 mt_sm--10 mb_sm--10">Hosting and Support</h2>
            <p className="disc rts-text-anim">
              Launch it, host it, support it - we’ve got you covered. From reliable website hosting to ongoing technical support, we ensure your site stays fast, secure, and always online. No downtime, no headaches - just smooth performance and expert help when you need it.
            </p>
            <Link to="/hosting-support" className="learn-more-btn mt--30">
              More Details{" "}
              <i className="fa fa-arrow-up-right-from-square icn-size28"></i>
            </Link>
          </div>
        </div>

        {/* Image Column - 1st on mobile, 2nd on desktop */}
        <div className="col-lg-6 order-1 order-lg-2 img-wrapper d-block text-center mb_sm--20">
          <img className="img-fluid" src={hosting} alt="product" />
        </div>
      </div>
    </div>          


        </div>
      </div>
 {/* Section End */}


  {/* Section Start */}

      <div className="services-scroll-item">
        <div className="projects-s__single topy-tilt">


    <div className="container mt--110 mt-md--50 mt-sm--30 services-bg">
      <div className="row align-items-center">
        {/* Text Column - 1st on desktop, 2nd on mobile */}
        <div className="col-lg-6 order-2 order-lg-1">
          <div className="content-wrapper">
            <span className="sub-title">Manikarn Digital</span>
            <h2 className="title mt--15 mb--20 mt_sm--10 mb_sm--10">Website Care</h2>
            <p className="disc rts-text-anim">
              Your website deserves more than “set it and forget it.” Our Website Care plans keep your site updated, secure, and running smoothly - every day. From checks to backups and updates, we handle it all so you can focus on what matters most: growing your business.
            </p>
            <Link to="/website-care" className="learn-more-btn mt--30">
              More Details{" "}
              <i className="fa fa-arrow-up-right-from-square icn-size28"></i>
            </Link>
          </div>
        </div>

        {/* Image Column - 1st on mobile, 2nd on desktop */}
        <div className="col-lg-6 order-1 order-lg-2 img-wrapper d-block text-center mb_sm--20">
          <img className="img-fluid" src={website} alt="product" />
        </div>
      </div>
    </div>          


        </div>
      </div>
 {/* Section End */}


    </div>
  </div>
  {/* ==== / banner end ==== */}


</div>
{/* ==== Services End ==== */}


</>



  );
};

export default ServiceSection;
